import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 7,
      icon: 'sociedades',
      name: i18n.t('imports.import_sociedades'),
    }, 
    {
      id: 6,
      icon: 'productos',
      name: i18n.t('imports.import_productos'),
    }, 
    {
      id: 4,
      icon: 'companies',
      name: i18n.t('imports.import_companies'),
    },
    {
      id: 1,
      icon: 'certificates',
      name: i18n.t('imports.import_certs_pfx'),
    }, 
    {
      id: 5,
      icon: 'certificates',
      name: i18n.t('imports.import_certs_serial'),
    }, 
    {
      id: 2,
      icon: 'group',
      name: i18n.t('imports.import_groups'),
    },
    {
      id: 3,
      icon: 'user',
      name: i18n.t('imports.import_users'),
    },

  ]
}

export function TIPOS_IMPORTACION (state) {
  return configHelper.getConfig(state, 'TIPOS_IMPORTACION', GenerateConfig)
}

